module.exports = __webpack_public_path__ + "static/media/Picverse-image-1-s.da743076.jpg";